/** Ajax */
import './index.scss'
import React from 'react'
import ComTable from './components/ComTable'
import DateTimePicker from '../../components/DateTimePicker/index'
import api from "../../lib/api";
import IconFont from '../../components/IconFont/index';
import { message,Input,Button  } from "antd";

class AjaxPage extends React.Component {
  isPageSizeChange = false;
  state = {
    dateTimeVal: '24小时',
    startTime: '',
    endTime: '',
    page: 1,
    pageSize: 30,
    tbData: [],
    orders: {},
    loading: false,
    showFilterPopup: false,
    filterData: {
      url: '',
      minCount: null,
      maxCount: null,
      minAvgRequestTime: null,
      maxAvgRequestTime: null
    },
    filterDataClone: {},
    pagination: {
      current: 1,
      pageSize: 30,
      defaultPageSize: 30,
      pageSizeOptions: [30, 50, 100],
      total: 0,
      showSizeChanger: true,
      showQuickJumper: true,
      onShowSizeChange: (current, size) => this.pageSizeChange(current, size),
      showTotal: total => `共 ${total} 条数据`,
    }
  };
  // 表格数据
  ajaxPageData() {
    this.setState({ loading: true });
    const { startTime, endTime, page, pageSize, orders,filterData } = this.state;
    const params = {
      startTime,
      endTime,
      page,
      pageSize,
      sortFile: orders.field || null,
      orderBy: orders.direct || null,
      ...filterData
    };
    api.ajaxPageData(params).then(res => {
      this.setState({ loading: false });
      if (res.success && res.status === 200) {
        this.setState({
          tbData: res.data || [],
          pagination: Object.assign(this.state.pagination, {
            pageSize: res.size,
            current: res.page,
            total: res.total
          })
        })
      } else {
        message.error(res.message);
      }
    })
  };
  // pageSize 改变
  pageSizeChange = (current, size) => {
    this.isPageSizeChange = true;
    this.setState({
      page: 1,
      pageSize: size
    }, () => {
      this.ajaxPageData();
    });
  };
  // 页数 或 排序变化
  pageChange = (pagination, filters, sorter, extra) => {
    if (this.isPageSizeChange) {
      this.isPageSizeChange = false;
      return
    }
    let page = extra.action === 'sort' ? 1 : pagination.current;
    let orders = {};
    if (sorter.order) {
      orders = {
        field: sorter.field,
        direct: sorter.order === "ascend" ? "asc" : "desc"
      }
    }
    this.setState({
      orders,
      page,
      pagination: Object.assign(this.state.pagination, { current: page, pageSize: pagination.pageSize }),
      pageSize: pagination.pageSize
    }, () => {
      this.ajaxPageData();
    });
  };
  // 日期时间控件
  handleDateTimePicker = (dateTimeVal, startTime, endTime) => {
    this.setState({
      dateTimeVal,
      startTime,
      endTime,
      page: 1,
      pagination: Object.assign(this.state.pagination, { current: 1 })
    }, () => {
      this.ajaxPageData();
    });
  };
  /** 显示/隐藏筛选弹窗 */
  handleShowFilter(bol) {
    bol ? this.setState({
      filterDataClone: JSON.parse(JSON.stringify(this.state.filterData))
    }) : this.setState({
      filterData: JSON.parse(JSON.stringify(this.state.filterDataClone))
    })
    this.setState({
      showFilterPopup: bol
    })
  };
  /** 更改筛选数据 */
  handleFilterChange(key, val) {
    let obj = this.state.filterData;
    obj[key] = val.target.value;
    this.setState({filterData:obj});
  };
  /** 确定筛选 */
  handleConfirmFilter(){
    this.ajaxPageData();
    this.setState({
      showFilterPopup: false
    })
  };
  render() {
    const { history } = this.props;
    const { dateTimeVal, startTime, endTime, loading, tbData, pagination,showFilterPopup,filterData } = this.state;
    return (
      <div className='card'>
        <div className='clear mBtm15'>
          <IconFont type="icon-shaixuantiaojian" style={{ fontSize: 26 }} className="filter-icon" onClick={() => this.handleShowFilter(true)} />
          <DateTimePicker comClassName='float-r' value={dateTimeVal} handleDateTimePicker={this.handleDateTimePicker} />
        </div>
        <ComTable dateTime={{ dateTimeVal, startTime, endTime }} history={history} loading={loading} tbData={tbData} pagination={pagination} pageChange={this.pageChange} />
        {/** 筛选弹窗 */}
        {showFilterPopup ? <div className="filter-popup">
          <div className="popup-shadow"></div>
          <div className="filter-module">
            <div className="filter-input">
              <div>
                <p>URL</p>
                <Input allowClear={true} value={filterData.url} onChange={val => this.handleFilterChange('url', val)} />
              </div>
              <div className="double-input">
                <p>调用次数</p>
                <Input value={filterData.minCount} onChange={val => this.handleFilterChange('minCount', val)} />
                <span>-</span>
                <Input value={filterData.maxCount} onChange={val => this.handleFilterChange('maxCount', val)} />
              </div>
              <div className="double-input">
                <p>平均响应耗时</p>
                <Input value={filterData.minAvgRequestTime} onChange={val => this.handleFilterChange('minAvgRequestTime', val)} />
                <span>-</span>
                <Input value={filterData.maxAvgRequestTime} onChange={val => this.handleFilterChange('maxAvgRequestTime', val)} />
              </div>
            </div>
            <p>
              <Button type="primary" onClick={() => this.handleConfirmFilter()} >确定</Button>
              <Button onClick={() => this.handleShowFilter(false)} >取消</Button>
            </p>
          </div>
        </div> : ''}
      </div>
    );
  }
}

export default AjaxPage
